/**
 * 시나리오 평가·수행결과 표에 쓰는 순수 포맷/판정 (JSX 없음).
 * 표 셀 컴포넌트는 `evaluationResultUtils.tsx`를 사용한다.
 */

/** 시나리오 평가결과 문자열(정답 / Completed / correct 등) 공통 판정 */
export function isScenarioAnswerCorrect(result: unknown): boolean {
  if (result == null) return false;
  const s = String(result);
  if (s === '') return false;
  return s === '정답' || s.toLowerCase() === 'completed' || s.toLowerCase() === 'correct' || s.toLowerCase() === 'success';
}

export function formatGenderAge(gender: unknown, age: unknown): string {
  const genderStr = 
    gender === true || gender === 'true' || gender === 'male' || gender === 'm' ? '남' :
    gender === false || gender === 'false' || gender === 'female' || gender === 'f' ? '여' :
    String(gender ?? '-');
  return [genderStr, age != null ? String(age) : '-'].filter(Boolean).join(' / ');
}
